import { render, staticRenderFns } from "./SkipCompetences.vue?vue&type=template&id=28005010&scoped=true"
import script from "./SkipCompetences.vue?vue&type=script&lang=js"
export * from "./SkipCompetences.vue?vue&type=script&lang=js"
import style0 from "./SkipCompetences.vue?vue&type=style&index=0&id=28005010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28005010",
  null
  
)

export default component.exports